import { DealsListResponse, PromotionsData } from '../types/Deals';

const FILE_BASE_URL = 'https://devapp.ectn.uz';

const toAbsoluteUrl = (url?: string | null) => {
  if (!url) {
    return '';
  }

  return url.startsWith('http') ? url : `${FILE_BASE_URL}${url}`;
};

export const dealsListAdapter = (
  response?: DealsListResponse
): PromotionsData => {
  const deals = response?.deals?.promoActions ?? [];
  const promoCodes = response?.promoCodes?.promoActions ?? [];

  return {
    deals: deals.map(promo => {
      // Язык выбрал бэкенд по заголовку Language. Нет блока или поля в нём —
      // базовые name/description, как раньше.
      const localized = promo.translations;
      const description = localized?.description || promo.description || '';
      // Картинки в translations нет — берём из imageTranslations на том же
      // языке, что и текст, чтобы они не разошлись.
      const image =
        (localized?.language &&
          promo.imageTranslations?.[localized.language]) ||
        promo.image;

      return {
        id: promo.ids?.externalId || promo.name || '',
        title: localized?.name || promo.name || '',
        description,
        shortDescription: description,
        imageUrl: toAbsoluteUrl(image),
        img: toAbsoluteUrl(image),
        createdAt: promo.startDateTimeUtc || new Date().toISOString(),
        createAt: promo.startDateTimeUtc
          ? new Date(promo.startDateTimeUtc)
          : new Date(),
        nameTranslations: promo.nameTranslations,
        descriptionTranslations: promo.descriptionTranslations,
        products: (promo.products ?? [])
          .map(product => Number(product))
          .filter(product => !Number.isNaN(product)),
        qrCodeUrl: promo.qrCodeUrl ? toAbsoluteUrl(promo.qrCodeUrl) : null,
        endDate: promo.endDateTimeUtc || null,
        // Пусто или одни пробелы — блока нет.
        fullDescription: localized?.full_description?.trim()
          ? localized.full_description
          : null,
      };
    }),
    promoCodes: promoCodes.map(promo => ({
      id: promo.ids?.value || promo.ids?.externalId || promo.name || '',
      title: promo.name || '',
      description: promo.description || '',
      imageUrl: toAbsoluteUrl(promo.image),
      img: toAbsoluteUrl(promo.image),
      qrPayload:
        promo.customFields?.promocode?.trim() || promo.externalId?.trim() || '',
      code:
        promo.customFields?.promocode?.trim() || promo.externalId?.trim() || '',
      nameTranslations: promo.nameTranslations,
      descriptionTranslations: promo.descriptionTranslations,
      endDate: promo.endDateTimeUtc || null,
    })),
  };
};
